import React from 'react';
import loadable from '@loadable/component';

export default function IconMapper({ name, size }) {
    const Icon = loadable(() => import(`./${name}`));
    return <Icon size={size} />;
}
